import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableCell,
  TableCellHead,
  TableHead,
  TableRow,
} from '~/ui/Table';
import EditIcon from '~/assets/svg/newSvg/edit.svg?react';
import i18next from 'i18next';

interface ITableProps {
  data: {
    id: number;
    object_id: string;
    event_name: string;
    created_at: string;
    type: { display_name: string; id: number };
  }[];
  sort: { field: string; direction: string };
  setSort: ({ field, direction }: { field: string; direction: string }) => void;
}

const transitionsData: {
  id: number;
  name: string;
  link: string;
  details?: string;
}[] = [
  { id: 1, name: i18next.t('announcements'), link: '/announcements' },
  { id: 2, name: i18next.t('applications'), link: '/requests' },
  { id: 3, name: i18next.t('orders'), link: '/transactions' },
  { id: 4, name: i18next.t('feedback'), link: '/feedback' },
  { id: 12, name: i18next.t('services'), link: '/services' },
  { id: 14, name: i18next.t('menu'), link: '/food', details: 'current' },
];

const EventsTable = ({ data, sort, setSort }: ITableProps) => {
  const { t } = useTranslation();

  return (
    <Table>
      <TableHead sort={sort} setSort={setSort}>
        <TableCellHead field="event">{t('event')}</TableCellHead>
        <TableCellHead field="created_at">{t('event_date')}</TableCellHead>
        <TableCellHead field="type_id">{t('event_type')}</TableCellHead>
        <TableCellHead field="type_id">{t('action')}</TableCellHead>
      </TableHead>
      <TableBody>
        {data?.map(item => {
          const currentTransition = transitionsData.find(
            transition => transition.id === item.type.id
          );
          return (
            <TableRow key={item.id}>
              <TableCell>{item.event_name}</TableCell>
              <TableCell>
                {dayjs(item.created_at).format('DD.MM.YYYY')}
              </TableCell>
              <TableCell>{item.type.display_name}</TableCell>
              <TableCell>
                {currentTransition ? (
                  <Link
                    to={`${currentTransition.link}/${item.object_id}${
                      currentTransition.details
                        ? `/${currentTransition.details}`
                        : ''
                    }`}
                  >
                    <EditIcon />
                  </Link>
                ) : (
                  '-'
                )}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default EventsTable;
